var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185870",
    "data-name": "Group 185870",
    transform: "translate(-342 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150171",
    "data-name": "Rectangle 150171",
    width: 24,
    height: 24,
    transform: "translate(342 542)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "delete_2550254",
    transform: "translate(313.867 545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63382",
    "data-name": "Path 63382",
    d: "M64.79,187.111a2.573,2.573,0,0,1-.524-.054v9.879a1.977,1.977,0,0,0,1.926,2.02h9.535a1.977,1.977,0,0,0,1.926-2.02v-9.879a2.571,2.571,0,0,1-.524.054H64.79Zm3.609,8.942a.524.524,0,1,1-1.047,0v-7.138a.524.524,0,1,1,1.047,0Zm3.085,0a.524.524,0,1,1-1.047,0v-7.138a.524.524,0,1,1,1.047,0Zm3.085,0a.524.524,0,1,1-1.047,0v-7.138a.524.524,0,1,1,1.047,0Z",
    transform: "translate(-30.956 -180.956)",
    fill: "#7263D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63383",
    "data-name": "Path 63383",
    d: "M46.217,2.353H43.355V2.02A1.983,1.983,0,0,0,41.415,0H38.591a1.983,1.983,0,0,0-1.94,2.02v.333H33.79a1.694,1.694,0,0,0-1.657,1.726A1.694,1.694,0,0,0,33.79,5.805H46.217a1.694,1.694,0,0,0,1.657-1.726A1.7,1.7,0,0,0,46.217,2.353Zm-8.51-.333a.9.9,0,0,1,.885-.922h2.824a.9.9,0,0,1,.885.922v.333H37.706Z",
    transform: "translate(0)",
    fill: "#7263D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.6d16e2a7615dd6f6ff04a0939cdca812.svg";
export { ForwardRef as ReactComponent };